import { useState, useCallback } from 'react';
import { PLAYERS } from '../data/players';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
function makeOpts(p){return shuffle([p.name,...shuffle(PLAYERS.filter(x=>x.id!==p.id)).slice(0,3).map(x=>x.name)]);}
export default function WhoIsPlayer({onBack,best,setBest}){
  const TOTAL=12;
  const [phase,setPhase]=useState('home');
  const [round,setRound]=useState([]);
  const [ri,setRi]=useState(0);
  const [opts,setOpts]=useState([]);
  const [sel,setSel]=useState(null);
  const [rev,setRev]=useState(false);
  const [score,setScore]=useState(0);
  const [streak,setStreak]=useState(0);
  const start=useCallback(()=>{
    const r=shuffle(PLAYERS).slice(0,TOTAL);
    setRound(r);setOpts(makeOpts(r[0]));setRi(0);setSel(null);setRev(false);setScore(0);setStreak(0);setPhase('play');
  },[]);
  const pick=useCallback((name)=>{
    if(sel!==null)return;setSel(name);setRev(true);
    const ok=name===round[ri].name;
    const ns=ok?score+1:score,nst=ok?streak+1:0;
    setScore(ns);setStreak(nst);if(ns>best)setBest(ns);
  },[sel,round,ri,score,streak,best,setBest]);
  const next=useCallback(()=>{
    if(ri+1>=TOTAL){setPhase('over');return;}
    const ni=ri+1;setRi(ni);setOpts(makeOpts(round[ni]));setSel(null);setRev(false);
  },[ri,round]);
  const p=round[ri],answered=sel!==null,ok=answered&&p&&sel===p.name,pct=(ri/TOTAL)*100;
  const grade=score>=11?'Eagle-Eyed Scout':score>=9?'Pro Talent Spotter':score>=7?'Regular Viewer':score>=4?'Casual Fan':'Never Watches Football';
  const cc=(name)=>{if(!answered)return'choice hv-p';if(name===p.name)return'choice correct';if(name===sel)return'choice wrong';return'choice dim';};
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title purple">WHO'S THE PLAYER?</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill p"><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className="g-pill p"><span className="g-plbl">Streak</span><span className="g-pval">{streak}{streak>=3?'🔥':''}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#c084fc',border:'1px solid #7c3aed'}}>World Cup Stars</div>
      <h1 className="game-big" style={{color:'#c084fc'}}>WHO'S THE PLAYER?</h1>
      <p className="game-desc">A portrait appears — <strong>blurred</strong> at first. Pick the right name. Reveals on answer.</p>
      {best>0&&<p className="game-best" style={{color:'#c084fc'}}>Best: {best}/{TOTAL}</p>}
      <button className="btn-purple" style={{marginTop:8}} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card" style={{background:'#120820',border:'1px solid #3a2060'}}>
      <div className="over-tag" style={{color:'#c084fc',border:'1px solid #7c3aed'}}>FINAL WHISTLE</div>
      <h1 className="over-h1">{grade}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#c084fc'}}>{score}</span><span className="over-lbl">Correct</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#c084fc'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button className="btn-purple" onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&p&&<div className="game-body" style={{alignItems:'center'}}>
      <div className="prog-row" style={{width:'100%'}}><div className="prog-bar"><div className="prog-fill-p" style={{width:pct+'%'}}/></div><span className="prog-pct">{ri+1}/{TOTAL}</span></div>
      <div className={'face-portrait-wrap '+(rev?'revealed':'')}>
        <div dangerouslySetInnerHTML={{__html:p.svg}}/>
        <div className={'face-blur '+(rev?'clear':'')}/>
        <div className="face-label" style={answered?{color:ok?'#4ade80':'#f87171',fontWeight:700}:{}}>{answered?p.name:p.nation}</div>
      </div>
      <div className="choices" style={{width:'100%'}}>{opts.map((name,i)=><button key={i} className={cc(name)} onClick={()=>pick(name)} disabled={answered}>{name}</button>)}</div>
      {answered&&<>
        <div className={'result-box '+(ok?'ok':'no')} style={{width:'100%'}}>
          <div className={'result-head '+(ok?'ok':'no')}>{ok?'Correct!':'That is '+p.name}</div>
          <div className="result-detail">{p.hint}</div>
        </div>
        <div className="game-actions" style={{width:'100%'}}>
          <span className="remaining">{ri+1<TOTAL?(TOTAL-ri-1)+' left':'Last player!'}</span>
          <button className="btn-next p" onClick={next}>{ri+1>=TOTAL?'Results →':'Next →'}</button>
        </div>
      </>}
    </div>}
  </div>);
}
